




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Banner } from '@/components';
import SwiperTop from './components/SwiperTop.vue';
import BottomTabbar from './components/BottomTabbar.vue';
import { isWeiXin } from '@/common/ts/common';
import { Button, Dialog, Toast, Popup } from 'vant';
import { getBaseInfo } from './api/index';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
import * as config from './config';
@Component({
  components: {
    Banner,
    BottomTabbar,
    SwiperTop,
  },
})
export default class Home extends Vue {
  baseInfo = {};
  pointOut = false;
  bannerImg = '';
  option = config.OPTHINES;
  created() {
    getBaseInfo().then((res: any) => {
      this.$addPv(res.data.activityId);
      this.baseInfo = res.data;
      this.bannerImg =
        res.data.banner.slice(0) + '?x-oss-process=image/resize,p_20';
    });
    // 分享
    setTimeout(() => {
      this.$appShareInfo({
        title: '力拼新未来·重庆当代足球队队报',
        url: window.location.href,
        subtitle: '力拼新未来·重庆当代足球队队报',
        classId: -1,
        id: -1,
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
        type: 3,
      });
    }, 500);
    this.$wxShareInfo({
      title: '力拼新未来·重庆当代足球队队报',
      subtitle: '力拼新未来·重庆当代足球队队报',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
